export const productTypeValues = [
  'prebidStack',
  'priceGenius',
  'refresher',
  'unfilledRecovery',
  'viewabilityTools',
] as const

export type Product = (typeof productTypeValues)[number]
